import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useListingModalContext } from "../../components/training-plan/material/listingModal/ListingModalProvider";

export const useListingModalLoading = () => {
  const userRedux = useSelector((state: RootState) => state.user.value);
  const { dispatch } = useListingModalContext();
  const listingRedux = useSelector((state: RootState) => state.trainingPlan);

  useEffect(() => {
    if (userRedux.rendered) {
      dispatch({ isLoading: false });
    } else if (!userRedux.rendered) {
      dispatch({ isLoading: true });
    }
  }, [userRedux, dispatch, listingRedux.gotSubscription]);
};
